const translations = {
  "en": {
    "What should I call you?": "What should I call you?",
    "Your name": "Your name"
  },
  "zh-tw": {
    "What should I call you?": "我該怎麼稱呼你？",
    "Your name": "你的姓名"
  }
};

export default translations;
